import React, { FC } from 'react';
import PlanningCard from './PlanningCard';
import Ticket from '../../../../../../interfaces/api/Ticket';

interface Props {
  ticket: Ticket;
  style?: Object;
  hidden?: boolean;
}

const PlanningCardContainer: FC<Props> = ({ ticket, style, hidden }) => {
  return <PlanningCard ticket={ticket} style={style} hidden={hidden} />;
};

export default React.memo(PlanningCardContainer);
